import { render, staticRenderFns } from "./orderPhotography.vue?vue&type=template&id=38be66ff&scoped=true&"
import script from "./orderPhotography.vue?vue&type=script&lang=js&"
export * from "./orderPhotography.vue?vue&type=script&lang=js&"
import style0 from "./orderPhotography.vue?vue&type=style&index=0&id=38be66ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38be66ff",
  null
  
)

export default component.exports